import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './containers/home/home.component';
import {SharedModule} from "../shared/shared.module";
import { CollectionCardComponent } from '../shared/components/collection-card/collection-card.component';
import { RouterModule } from '@angular/router'
import { UiModule } from '../ui/ui.module'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,

    SharedModule,
    UiModule
  ],
  declarations: [
    HomeComponent
  ],
  exports: [
    HomeComponent
  ]
})
export class HomeModule { }



// WEBPACK FOOTER //
// C:/Users/Thomas/Projekte/palettes/src/app/home/home.module.ts